export default {
  data: null,
  error: null,
  loading: false,
  availableDatesLoading: false,
  doctorsFilter: [],
  availableDates: []
}
